<template>
  <div class="episodes-content">
    <div v-click-outside="onClickOutside" class="modal-episodes">
      <div class="item--title">
        <span class="item--title"> {{ episode.name }} </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            class="item--close-icon"
            id="user--btn-icon"
            icon="times"
        /></span>
      </div>
      <figure class="movie--img--item">
        <div
          v-if="episode && episode.imageUrl"
          v-lazy-container="{ selector: 'img' }"
        >
          <img
            class="movie--img--item"
            :data-src="episode.imageUrl"
            :alt="episode.title"
          />
        </div>
        <div
          v-else-if="show && show.imageUrl != null"
          v-lazy-container="{ selector: 'img' }"
        >
          <img
            class="movie--img--item"
            :data-src="show.imageUrl"
            :alt="episode.title"
          />
        </div>
        <div v-else>
          <img class="movie-no-img" src="/img/no_image.png" />
        </div>
      </figure>
      <div class="detail_episode">
        <p>{{ episode.description }}</p>
        <button class="item--btn btn-episodes" @click.prevent="closeModal">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "IthEpisodesModal",
  data: () => ({
    episodes: false,
    directives: {
      clickOutside: vClickOutside.directive,
    },
    form: { email: "" },
    alert: { color: "", message: "" },
  }),
  computed: mapState(["menuAsside", "episode", "show"]),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "episodes-content") {
        this.$store.commit("DISABLED_MENU");
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.$store.commit("TOGGLE_EPISODES_MODAL");
      this.$store.commit("DISABLED_MENU");
    },
    async sendForgotPassword() {
      await this.$Parse.User.requestPasswordReset(this.form.email)
        .then(() => {
          this.alert.color = "#94C659";
          this.alert.message = "Email Sent";
          this.$store.commit("editAlert", this.alert);
          this.$store.commit("DISABLED_MENU");
        })
        .catch((response) => {
          this.alert.color = "#EF3D58";
          this.alert.message = response.message;
          this.$store.commit("editAlert", this.alert);
        });
    },
  },
};
</script>

<style scoped>
.episodes-content {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 10vh;
}
.modal-episodes {
  background-color: #284060;
  min-height: 500px;
  width: 35vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 50px 200px 220px;
  row-gap: 20px;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}
.movie-no-img {
  border-radius: 10px;
  width: 30%;
  max-height: 150px;
  object-fit: contain;
  margin: 10% 35%;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 20px;
  font-weight: 600;
}

.movie--img--item {
  padding: 0px;
  margin: 0px;
  width: 100%;
  max-height: 200px;
  border-radius: 10px;
  object-fit: cover;
  z-index: 1001;
}

.detail_episode {
  text-align: center;
  padding-top: 5px;
  margin-bottom: 20px;
  height: 100%;
  align-self: end;
  /* overflow-y: scroll; */
  overflow: auto;
}

.detail_episode::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.detail_episode::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.detail_episode::-webkit-scrollbar-thumb {
  background-color: #4465a1;
}

.item--btn {
  margin: 7px 0;
  border: none;
  border-radius: 20px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}
.item--register {
  text-align: center;
}
.btn-episodes {
  background-color: rgba(44, 56, 72, 0.8);
  font-size: 16px;
  font-weight: 400;
  height: 40px;
  width: 100%;
  margin: 10px auto;
}
.item--episodes {
  cursor: pointer;
}
@media (min-width: 1480px) {
  .modal-episodes {
    height: 50vh;
    width: 30vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-episodes {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-episodes {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-episodes {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-episodes {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-episodes {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-episodes {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
    grid-template-rows: 50px 190px 250px;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
  .movie--img--item {
    align-self: center;
    max-height: 190px;
  }
}
</style>
